import Api from "./Api";
import Csrf from "./Csrf";
import axios from "axios";

export default {
  async register(form) {
    await Csrf.getCookie();

    return Api.post("/register", form);
  },

  async login(form) {
    await Csrf.getCookie(true);

    return Api.post("/login", form);
  },

  async logout() {
    await Csrf.getCookie();

    return Api.post("/logout");
  },

  auth(device_id) {
    return Api.post("/user", {'device_id' : device_id});
  },    
    
  async update(form) {
    await Csrf.getCookie();

    return Api.patch("/user", form);
  },
    
  async index() {
    await Csrf.getCookie();

    return Api.get("/users");
  },
    
  async add(form) {
    await Csrf.getCookie();

    return Api.post("/users", form);
  },
    
  async delete(id) {
    await Csrf.getCookie();

    return Api.delete("/users/" + id);      
      
  },
	
	checkOnlineStatus(timestamp,project_id,lszsz,device_id){
		return axios.post(process.env.VUE_APP_BACKEND_URL + "/tc26api/get-finished-places/"+timestamp,{
			'project_id':project_id,
			'lszsz':lszsz,
			'device':device_id
		});
	},
};